import PropTypes from "prop-types";
import React from "react";

import { ProductShape } from "../../policies/proptypes";
import ScopeTypesByProduct from "../containers/ScopeTypesByProduct";

const ScopeTypesList = ({ products }) => (
  <div className="l-scopes__column" style={{ gridArea: "scopes-list" }}>
    <div className="l-scopes__column-header">
      <span className="p-muted-heading u-no-margin--bottom">Scopes</span>
    </div>
    <div className="l-scopes__column-panel">
      <ul className="p-list">
        {products.map(product => (
          <ScopeTypesByProduct key={product.$uri} product={product} />
        ))}
      </ul>
    </div>
  </div>
);

ScopeTypesList.propTypes = {
  products: PropTypes.arrayOf(ProductShape).isRequired
};

export default ScopeTypesList;
